import React, { useState, useRef } from 'react' 
import CustomHook from './CustomHook';
import '../styles/Projects.css';
import projectData from '../data/projects.json'; 

function Projects() {
  const [listProjects] = useState(projectData.projects);
    
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);
  return (
    <section className='projects' ref={scrollTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        My Projects
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}>
        {/* 20 */}
        Here are a few of my projects I've worked on. You can find the source code for my personal projects on my GitHub profile.
        <br />Illustrations by <a href="https://pictographic.io" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>PictoGraphic.io</a>
      </div>
      <div className="list">
        {
          listProjects.map((value, key) => (
            <div className='item' key={key} ref={(el) => el && divs.current.push(el)}>
              <div className="images">
                <img src={value.images} alt="" />
              </div>
              <div className="content">
                <h3>{value.name}</h3>
                <div className="des">{value.des}</div>
                <div className="mission">
                    <div><strong>Goal</strong></div>
                    <div>
                        <div className="des">{value.mission}</div>
                    </div>
                </div>
                <div className="mission">
                  <div><strong>Tech Stack</strong></div>
                  <div>
                    <div className="des">{value.tech}</div>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </section>
  )
}

export default Projects